import React from 'react';
import ToolManagmentCard from '../../../../../../../common/element/Card/ToolManagmnetCard';

const CompanyBasicDetailsCard = ({ companyData }) => {

    // ✅ Helper function to format phone number
    const formatPhoneNumber = (phone) => {
        if (!phone) return 'N/A';
        if (phone.length > 10) {
            const countryCode = phone.slice(0, phone.length - 10);
            const number = phone.slice(-10);
            return `+${countryCode} ${number.slice(0, 5)} ${number.slice(5)}`;
        }
        return phone;
    };

    // ✅ Get HR full name
    const getHRFullName = () => {
        if (companyData?.hr) {
            const firstName = companyData.hr.first_name || '';
            const lastName = companyData.hr.last_name || '';
            return `${firstName} ${lastName}`.trim() || 'N/A';
        }
        return 'N/A';
    };

    return (
        <>
            <ToolManagmentCard>
                <div className="flex justify-between items-center py-4 border-b border-gray-200">
                    <h2 className="font-lato font-semibold text-[16px] leading-[150%] text-[#101828] text-start">Basic Details</h2>
                </div>

                {/* Information Grid */}
                <div className="py-6">
                    <div className="grid grid-cols-3 gap-x-6 gap-y-4">
                        {/* Company Name */}
                        <div className="text-start">
                            <label className="block font-lato font-medium text-[14px] text-[#98A2B3]">
                                Company Name
                            </label>
                            <p className="font-lato font-medium text-[16px] text-[#101828] mb-0">
                                {companyData?.company_name || 'N/A'}
                            </p>
                        </div>

                        {/* Contact Person */}
                        <div className="text-start">
                            <label className="block font-lato font-medium text-[14px] text-[#98A2B3]">
                                Contact Person
                            </label>
                            <p className="font-lato font-medium text-[16px] text-[#101828] mb-0">
                                {companyData?.contact_person || 'N/A'}
                            </p>
                        </div>

                        {/* Contact Phone */}
                        <div className="text-start">
                            <label className="block font-lato font-medium text-[14px] text-[#98A2B3]">
                                Contact Phone
                            </label>
                            <p className="font-lato font-medium text-[16px] text-[#101828] mb-0">
                                {formatPhoneNumber(companyData?.contact_phone)}
                            </p>
                        </div>

                        {/* Contact Email */}
                        <div className="text-start">
                            <label className="block font-lato font-medium text-[14px] text-[#98A2B3]">
                                Contact Email
                            </label>
                            <p className="font-lato font-medium text-[16px] text-[#101828] mb-0">
                                {companyData?.contact_email || 'N/A'}
                            </p>
                        </div>

                        {/* HR Name */}
                        <div className="text-start">
                            <label className="block font-lato font-medium text-[14px] text-[#98A2B3]">
                                HR Name
                            </label>
                            <p className="font-lato font-medium text-[16px] text-[#101828] mb-0">
                                {getHRFullName()}
                            </p>
                        </div>

                        {/* HR Phone No. */}
                        <div className="text-start">
                            <label className="block font-lato font-medium text-[14px] text-[#98A2B3]">
                                HR Phone No.
                            </label>
                            <p className="font-lato font-medium text-[16px] text-[#101828] mb-0">
                                {formatPhoneNumber(companyData?.hr?.mobile_number)}
                            </p>
                        </div>

                        {/* HR Email */}
                        <div className="text-start">
                            <label className="block font-lato font-medium text-[14px] text-[#98A2B3]">
                                HR Email
                            </label>
                            <p className="font-lato font-medium text-[16px] text-[#101828] mb-0  break-all ">
                                {companyData?.hr?.email || 'N/A'}
                            </p>
                        </div>

                        {/* Quota */}
                        <div className="text-start">
                            <label className="block font-lato font-medium text-[14px] text-[#98A2B3]">
                                Quota
                            </label>
                            <p className="font-lato font-medium text-[16px] text-[#101828] mb-0">
                                {companyData?.quota ?? 'N/A'}
                            </p>
                        </div>

                       

                        {/* Address */}
                        <div className="text-start">
                            <label className="block font-lato font-medium text-[14px] text-[#98A2B3]">
                                Address
                            </label>
                            <p className="font-lato font-medium text-[16px] text-[#101828] mb-0">
                                {companyData?.address || 'N/A'}
                            </p>
                        </div>
                        {/* Country */}
                        <div className="text-start">
                            <label className="block font-lato font-medium text-[14px] text-[#98A2B3]">
                                Country
                            </label>
                            <p className="font-lato font-medium text-[16px] text-[#101828] mb-0">
                                {companyData?.country?.country_name || 'N/A'}
                            </p>
                        </div>
                        {/* State */}
                        <div className="text-start">
                            <label className="block font-lato font-medium text-[14px] text-[#98A2B3]">
                                State
                            </label>
                            <p className="font-lato font-medium text-[16px] text-[#101828] mb-0">
                                {companyData?.state?.state_name || 'N/A'}
                            </p>
                        </div>

                        {/* City */}
                        <div className="text-start">
                            <label className="block font-lato font-medium text-[14px] text-[#98A2B3]">
                                City
                            </label>
                            <p className="font-lato font-medium text-[16px] text-[#101828] mb-0">
                                {companyData?.city?.city_name || 'N/A'}
                            </p>
                        </div>

                        {/* Pincode */}
                        <div className="text-start">
                            <label className="block font-lato font-medium text-[14px] text-[#98A2B3]">
                                Pincode
                            </label>
                            <p className="font-lato font-medium text-[16px] text-[#101828] mb-0">
                                {companyData?.pincode || 'N/A'}
                            </p>
                        </div>



                    </div>
                </div>
            </ToolManagmentCard>
        </>
    );
};

export default CompanyBasicDetailsCard;